/**
 * Maps links the API stored before a route was renamed to the route that exists now, so old notifications and tasks still land
 * on a page: GSOC submissions are reviews, and ministry consultation requests live under the consultation area.
 */
export function normalizeLink(link: string): string {
  const [path = "", query = ""] = link.split("?");
  const submission = /^\/oversight\/submissions(?:\/([^/]+))?$/.exec(path);
  if (submission) return submission[1] ? `/oversight/reviews/${submission[1]}` : "/oversight/reviews";
  if (path === "/consultations" && query.includes("tab=requests")) return "/consultation/requests";
  const round = /^\/consultations\/([^/]+)$/.exec(path);
  if (round) return `/consultation?round=${round[1]}`;
  if (path === "/consultations") return "/consultation";
  return link;
}
